import { graphql, useStaticQuery } from 'gatsby';

const useCoronaPosts = excludeId => {
  const { allContentfulBlog } = useStaticQuery(graphql`
    query {
      allContentfulBlog(
        filter: { tags: { eq: "Covid19" } }
        sort: { fields: [publishDate], order: DESC }
        limit: 4
      ) {
        edges {
          node {
            id
            title
            seo {
              ...Seo
            }
            author
            excerpt {
              excerpt
            }
            thumbnail
            featuredImage {
              fluid(quality: 100) {
                ...GatsbyContentfulFluid_withWebp_noBase64
              }
            }
            publishDate(formatString: "MMMM DD, YYYY")
          }
        }
      }
    }
  `);
  return allContentfulBlog?.edges.filter(x => x.node.id !== excludeId).slice(0, 3);
};

export default useCoronaPosts;
